/**
 * @generated SignedSource<<aeaa8cb6cea41e50d2db1d680a649977>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveCommentReactionInput = {
  commentId: string;
  emoji: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type removeCommentReactionMutation$variables = {
  input: RemoveCommentReactionInput;
};
export type removeCommentReactionMutation$data = {
  readonly removeCommentReaction: {
    readonly comment: {
      readonly id: string;
      readonly reactions: ReadonlyArray<{
        readonly emoji: string;
        readonly count: number;
        readonly viewerHasReacted: boolean;
        readonly persons: ReadonlyArray<{
          readonly id: string;
          readonly fullName: string | null;
        }>;
      }>;
    } | null;
  } | null;
};
export type removeCommentReactionMutation = {
  variables: removeCommentReactionMutation$variables;
  response: removeCommentReactionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveCommentReactionPayload",
    "kind": "LinkedField",
    "name": "removeCommentReaction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentType",
        "kind": "LinkedField",
        "name": "comment",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CommentReactionType",
            "kind": "LinkedField",
            "name": "reactions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emoji",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerHasReacted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "persons",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "removeCommentReactionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeCommentReactionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cac3ad3c94925ec4d492e4930095670e",
    "id": null,
    "metadata": {},
    "name": "removeCommentReactionMutation",
    "operationKind": "mutation",
    "text": "mutation removeCommentReactionMutation(\n  $input: RemoveCommentReactionInput!\n) {\n  removeCommentReaction(input: $input) {\n    comment {\n      id\n      reactions {\n        emoji\n        count\n        viewerHasReacted\n        persons {\n          id\n          fullName\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c8d202c419cc018a29045230e936497";

export default node;
